export class FileHelper {
  static download(content: string, filename: string, mimetype: string) {
    let blob = new Blob([content], { type: mimetype });
    let link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      let url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  static arrayToCsv(rows) {
    let processRow = function (row) {
      let finalVal = '';
      for (let j = 0; j < row.length; j++) {
        let innerValue = row[j] === null ? '' : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        }
        let result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
        if (j > 0) finalVal += ';';
        finalVal += result;
      }
      return finalVal + '\n';
    };

    let csvFile = '';
    for (const element of rows) {
      csvFile += processRow(element);
    }

    return csvFile;
  }
}
